module.exports = __webpack_public_path__ + "img/36.1dcaef99.jpg";